import { type ReactNode } from "react";
import { createPortal } from "react-dom";
import { cn } from "~/lib/utils";
import { useMapLayout } from "./useMapLayout";
import { REGION_IDS } from "./constants";

interface ControlsProps {
  children: ReactNode;
  className?: string;
}

/**
 * MapLayout.Controls - Bottom-right control buttons (FAB area).
 */
export default function Controls({ children, className }: ControlsProps) {
  const { mounted, sheetStep } = useMapLayout();

  if (!mounted) return null;

  const target = document.getElementById(REGION_IDS.controls);
  if (!target) return null;

  return createPortal(
    <div className={cn("flex flex-col items-center gap-3", className)} data-sheet-step={sheetStep ?? undefined}>
      {children}
    </div>,
    target,
  );
}
